import './confirmModal.scss'
import { useState, useEffect } from 'react';
import icons from '../../../../helpers/iconMenu';
import Icon from '../../../../components/icon-component/Icon';
import apiLanguageMethodService from '../../api/apiLanguages';
import Text from '../../../../components/text-component/Text';
import { getStaticText } from '../../../../lables/lablesService';
import Button from '../../../../components/button-component/Button';

/**
 * Confirm modal conponent
 * 
 * @params closeConfirm - func
 * @params setDataTable - func
 * @params confirmId    - number    
 * @params dataTable    - arr obj       
 * @returns JSX
 */
const ConfirmModal = ({
    dataTable,
    confirmId,
    setDataTable,
    closeConfirm,
    fetchPageList,
}) => {

    //State for mount component
    const [didMount, setDidMount] = useState(false);
    //State for disabled button
    const [disabledBtn, setDisabledBtn] = useState(false);
    //State for the duplicate value error message
    const [successfulDeleteMsg, setSuccessfulDeleteMsg] = useState("");
    //State for the duplicate value error message
    const [unsuccessfulDeleteMsg, setUnsuccessfulDeleteMsg] = useState("");
    //State for show/hide error message
    const [isAlertSuccessfulVisible, setIsAlertSuccessfulVisible] = useState(false);
    //State for show/hide error message
    const [isAlertUnsuccessfulVisible, setIsAlertUnsuccessfulVisible] = useState(false);

    /**
     * Method delete row in the table
     * 
     * @params id number
     * @returns 
     */
    const deleteRow = async id => {

        if (disabledBtn) return;

        setDisabledBtn(prev => !prev);

        const response = await apiLanguageMethodService.deleteLanguageList(id);

        // Condition response error
        if (response.error) {
            setUnsuccessfulDeleteMsg(response.errors[0])
            return
        }

        // Condition response success
        if (!response.error) {
            setSuccessfulDeleteMsg(getStaticText('lng_delete_success'));
            setDataTable(dataTable.filter(row => row.id !== id));
            await fetchPageList();
        }

        return response;
    }

    useEffect(() => {
        let timer;

        if (unsuccessfulDeleteMsg) {
            setIsAlertUnsuccessfulVisible(true)

            timer = window.setTimeout(() => {
                setIsAlertUnsuccessfulVisible(false);
                setUnsuccessfulDeleteMsg("");
                setDisabledBtn(prev => !prev);
            }, 3000)
        }
        return () => window.clearTimeout(timer);

    }, [unsuccessfulDeleteMsg, setUnsuccessfulDeleteMsg])

    useEffect(() => {
        let timer;

        if (successfulDeleteMsg) {
            setIsAlertSuccessfulVisible(true)

            timer = window.setTimeout(() => {
                setIsAlertSuccessfulVisible(false);
                setSuccessfulDeleteMsg("")
                closeConfirm()
            }, 3000)
        }

        return () => window.clearTimeout(timer);

    }, [successfulDeleteMsg, setSuccessfulDeleteMsg, closeConfirm])

    useEffect(() => {
        setDidMount(true);
        return () => setDidMount(false);
    }, [])

    if (!didMount) {
        return null;
    }

    return (
        <div className="d-flex justify-content-center align-items-center color-wite">

            <div className="p-4 pt-4 pb-2 col modal_language_confirm">
                <Text
                    text_style={"text-center text-danger h5"}
                    content={getStaticText('delete_confirm_msg')}
                >
                    <Icon
                        onClick={closeConfirm}
                        icon_style={icons.lng_form_remove}
                        icon_className={"lng_icon_remove_confirm"}
                    />
                </Text>

                {/* Render success unsuccess error message */}
                {
                    isAlertUnsuccessfulVisible &&
                    (unsuccessfulDeleteMsg &&
                        <Text
                            content={unsuccessfulDeleteMsg}
                            text_style={"alert alert-danger p-0 pt-1 pb-1 text-center h6"}
                        />
                    )
                }
                {
                    isAlertSuccessfulVisible &&
                    (successfulDeleteMsg &&

                        <Text
                            content={successfulDeleteMsg}
                            text_style={"alert alert-success p-0 pt-1 pb-1 text-center h6"}
                        />
                    )
                }

                <div className="d-flex justify-content-evenly">
                    <Button
                        type={"button"}
                        bgcolor={"warning"}
                        btn_disabled={disabledBtn}
                        onClick={() => deleteRow(confirmId)}
                        btn_styles={"p-4 pt-0 pb-0 btn-active text-white shadow-none mt-2 mb-2"}
                        label={disabledBtn ? getStaticText('loading_btn') : getStaticText('delete_confirm_btn_yes')}
                    />
                </div>
            </div>
        </div>
    )
}

export default ConfirmModal;